<template>
  <v-card class="m-4" elevation="0">
    <v-card-text class="pa-4">
      <promissory-note-table
        :items="items"
        :loading="loading"
        :role="roles.CREDIT_COLLECTIONS"
        :is-status-editable="true"
        :with-customer-action="true"
        :with-filters="true"
        :with-title="true"
        :headers="headers"
        :searchable="true"
        :exportable="true"
        @statusHasChanged="setStatus"
        @editPromissory="openStatusDialog"
        @markedAsComplete="markedAsComplete"
        @rejectPromissory="openStatusDialog"
      >
        <template #header>
          <v-icon large class="text-black"> mdi-cash </v-icon>
          SOLICITUDES DE PAGARÉS
        </template>
      </promissory-note-table>
    </v-card-text>

    <v-dialog v-model="form.dialog" :persistent="loading" width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5"
            >{{ form.is_rejectable ? 'Rechazar' : 'Revisar' }} solicitud de
            pagaré</span
          >
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <template v-if="!form.is_rejectable">
              <v-col cols="6">
                <v-subheader> Estatus </v-subheader>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="form.status"
                  :disabled="loading"
                  :items="[
                    { label: 'Aceptar', value: 'VOIEL' },
                    { label: 'Rechazar', value: 'RBC' },
                  ]"
                  item-text="label"
                  outlined
                  dense
                  item-value="value"
                  label="Selecciona el estatus"
                />
              </v-col>
              <v-col>
                <simple-currency-input
                  v-model="form.credit_line_approved"
                  label="Confirmar línea de crédito del nuevo pagaré"
                  :disabled="loading"
                />
              </v-col>
            </template>

            <v-col cols="12" col="6">
              <v-textarea
                v-model="form.comment"
                :disabled="loading"
                outlined
                dense
                label="Agregue un comentario"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            :disabled="loading"
            :loading="loading"
            @click="closeDialog"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="primary darken-1"
            :loading="loading"
            :disabled="loading"
            @click="saveData"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from '@/plugins/axios';
  import { Roles } from '@/core/constants/roleConstants';
  import PromissoryNoteTable from '../client_request/promissory_notes/components/PromissoryNoteTable.vue';
  import SimpleCurrencyInput from '@/components/inputs/SimpleCurrencyInput.vue';

  export default {
    name: '',
    components: { PromissoryNoteTable, SimpleCurrencyInput },

    data: () => ({
      loading: false,
      url: '',
      search: '',
      form: {
        dialog: false,
        creditnoteId: null,
        status: null,
        comment: null,
        credit_line_approved: 0,
        promissoryNoteId: null,
      },
      params: {
        status: '',
        search: '',
        channel: '',
        role: '',
      },
      items: [],
      headers: [
        { text: 'Fecha (dd/mm/aaaa)', value: 'created' },
        { text: 'Oficina', value: 'sales_office' },
        { text: 'Canal', value: 'channel' },
        { text: 'Nº Cliente', value: 'customer_id' },
        {
          text: 'Nombre del cliente',
          value: 'customer_name',
          cellClass: 'text-nowrap ',
        },
        {
          text: 'Id asesor',
          align: 'start',
          sortable: false,
          cellClass: 'text-nowrap',
          value: 'seller_id',
        },
        {
          text: 'Nombre de asesor',
          align: 'start',
          sortable: false,
          cellClass: 'text-nowrap',
          value: 'seller_name',
        },
        {
          text: 'Pagaré',
          align: 'start',
          sortable: false,
          value: 'promissory_note_amount',
        },
        {
          text: 'Línea de credito disponible',
          align: 'start',
          sortable: false,
          value: 'credit_line',
        },
        {
          text: 'L. Credito solicitada',
          align: 'start',
          sortable: false,
          value: 'credit_line_amount_requested',
        },
        {
          text: 'L. Credito aprobado',
          align: 'start',
          sortable: false,
          cellClass: 'text-nowrap',
          value: 'credit_line_amount_approved',
        },
        { text: 'Estatus', value: 'status' },
        { text: 'Tipo de solicitud', value: 'request_type.description' },
        {
          text: 'Observaciones',
          value: 'comments',
          align: 'center',
          exportable: false,
        },
        {
          text: 'Archivos',
          value: 'files',
          cellClass: 'text-nowrap',
          exportable: false,
        },
        { text: 'Acciones', value: 'actions', exportable: false },
      ],
    }),
    computed: {
      roles() {
        return Roles;
      },
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    mounted() {
      this.params.channel = `${this.user.VTWEG}`;
      this.params.role = Roles.CREDIT_COLLECTIONS;
    },
    methods: {
      async markedAsComplete(promissoryNote) {
        this.form.promissoryNoteId = promissoryNote.id;

        const isUpdated = await this.fetchUpdatePromissoryNoteData({
          status: 'COMP',
        });
        if (isUpdated) {
          this.$toast.success('Operación procesada correctamente');
          this.form.dialog = false;
          this.form.comment = '';
          this.loadPromissoryNotes();
        }
        this.closeDialog();
      },
      setStatus(status) {
        this.params.status = status;
        this.loadPromissoryNotes();
      },
      async loadPromissoryNotes() {
        this.loading = true;
        this.items = [];
        try {
          const response = await axios.post(
            '/promissory-notes/requests/all',
            this.params
          );
          this.items = response.data;
        } catch (error) {
          this.$swal({
            title: 'Ocurrio un error al recuperar las solicitudes',
            text: 'Servicio no disponible, por favor intente más tarde',
            type: 'warning',
          });
        }
        this.loading = false;
      },
      openStatusDialog(promissoryNote) {
        this.form.dialog = true;
        this.form.comment = '';
        this.form.status = promissoryNote.status.key;
        this.form.promissoryNoteId = promissoryNote.id;
        this.form.credit_line_approved =
          promissoryNote.credit_line_amount_requested;
        this.form.is_rejectable = promissoryNote.status.key == 'VOIEL';
      },
      closeDialog() {
        this.form.dialog = false;
        this.form.promissoryNoteId = null;
        this.form.status = null;
      },

      async fetchUpdatePromissoryNoteData(params = {}) {
        try {
          this.loading = true;
          await axios.put(
            `/promissory-notes/requests/update/${this.form.promissoryNoteId}`,
            params
          );
        } catch (error) {
          this.$swal.fire({
            title: `${error}`,
            icon: 'warning',
            type: 'warning',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#3085d6',
          });
          return false;
        }
        this.loading = false;
        return true;
      },
      validateFields() {
        if (!this.form.status) {
          this.$toast.error('Es requerido seleccionar un estatus');
          return false;
        }
        if (
          !this.form.comment &&
          this.form.is_rejectable &&
          this.form.status == 'RBC'
        ) {
          this.$toast.error(
            'Es requerido seleccionar un estatus y agregar un comentario'
          );
          return false;
        }
        return true;
      },
      async saveData() {
        if (!this.validateFields()) return;
        const isUpdated = await this.fetchUpdatePromissoryNoteData({
          status: this.form.is_rejectable ? 'RBC' : this.form.status,
          comment: this.form.comment,
          user: this.user.sap_id,
          amount: !this.form.is_rejectable ? this.form.credit_line_approved : 0,
        });
        if (isUpdated) {
          this.$toast.success('Operación procesada correctamente');
          this.form.dialog = false;
          this.loadPromissoryNotes();
        }
        this.closeDialog();
      },
    },
  };
</script>
